import store from '../store/index'
import axios from 'axios'
// Vi importerer instansen OG stop-knappen fra din axios/index.js
import api, { axiosConfig } from '../axios/index'

let requestsTotal = 0
let requestCompleted = 0
let postTotal = 0
let postCompleted = 0

const get = (path, data, cb, errorCb) => {
    requestsTotal++
    store.state.loading = true
    store.state.errors = []
    // Vi bruger 'api' instansen og tilføjer det aktuelle cancelToken
    api.get(path, {
        params: data,
        cancelToken: axiosConfig.cancelTokenSource.token
    })
    .then((response) => {
        requestCompleted++
        loading()
        cb(response)
    }).catch(error => {
        requestCompleted++
        loading()
        // Hvis kaldet er stoppet af routeren, gør vi intet
        if (axios.isCancel(error)) {
            return
        }
        if (errorCb) errorCb(error)
    })
}

const remove = (path, cb, errorCb) => {
    requestsTotal++
    store.state.loading = true
    store.state.errors = []
    api.delete(path, {
        cancelToken: axiosConfig.cancelTokenSource.token
    })
    .then((response) => {
        requestCompleted++
        loading()
        cb(response)
    }).catch(error => {
        requestCompleted++
        loading()
        if (axios.isCancel(error)) return
        if (errorCb) errorCb(error)
    })
}

const post = (path, data, cb, errorCb) => {
    postTotal++
    store.state.inputLoading = true
    api.post(path, data) // Ingen cancelToken på POST/PUT/PATCH
        .then((response) => {
            postCompleted++
            PostLoading()
            cb(response)
        }).catch(error => {
        postCompleted++
        PostLoading()
        if (errorCb !== undefined) {
            errorCb(error.response)
        }
    })
}

const put = (path, data, cb, errorCb) => {
    postTotal++
    store.state.inputLoading = true
    store.state.errors = []
    data['_method'] = 'PUT'
    api.post(path, data)
        .then((response) => {
            postCompleted++
            PostLoading()
            cb(response)
        }).catch(error => {
        postCompleted++
        PostLoading()
        if (error.response !== undefined) {
            if (error.response.status === 422) {
                store.state.errors = error.response.data
            }
        }
    })
}

const patch = (path, data, cb, errorCb) => {
    postTotal++
    store.state.inputLoading = true
    store.state.errors = []
    data['_method'] = 'PATCH'
    api.post(path, data)
        .then((response) => {
            postCompleted++
            PostLoading()
            cb(response)
        }).catch(error => {
        postCompleted++
        PostLoading()
        if (error.response !== undefined) {
            if (error.response.status === 422) {
                store.state.errors = error.response.data
            }
        }
    })
}

function loading () {
    if (requestsTotal <= requestCompleted) {
        requestsTotal = 0
        requestCompleted = 0
        store.state.loading = false
    }
}

function PostLoading () {
    if (postTotal <= postCompleted) {
        postTotal = 0
        postCompleted = 0
        store.state.inputLoading = false
    }
}

export {
    get,
    remove,
    post,
    put,
    patch
}



// WEBPACK FOOTER //
// ./src/services/HttpService.js